import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/subzbbg_02.png'


const _withScopeId = n => (_pushScopeId("data-v-28da7396"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "bottomBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "inputBox" }
const _hoisted_6 = { class: "inputList" }
const _hoisted_7 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.zbxxsc'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("img", {
      class: "topbg",
      src: $setup.subzbbg,
      alt: ""
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: $setup.form.phonenumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.phonenumber) = $event)),
                type: "tel",
                label: $setup.th == 'th' ? '' : '手机号码',
                placeholder: $setup.t('me.inputphone')
              }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_van_field, {
                modelValue: $setup.form.checknumber,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.checknumber) = $event)),
                label: $setup.th == 'th' ? '' : $setup.t('me.code'),
                placeholder: $setup.t('me.inputphonecode')
              }, {
                button: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "yanzhengma",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.checkn()))
                  }, _toDisplayString($setup.count == 0 ? $setup.t('me.hqyzm') : $setup.count), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_van_field, {
                modelValue: $setup.form.nickname,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.nickname) = $event)),
                label: $setup.th == 'th' ? '' : $setup.t('me.xingming'),
                placeholder: $setup.t('me.qsrzsmz')
              }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_van_field, {
                modelValue: $setup.form.nicknumber,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => (($setup.form.nicknumber) = $event)),
                  $setup.checkText
                ],
                label: $setup.th == 'th' ? '' :$setup.t('me.zjhm'),
                placeholder: $setup.t('me.qsrsfz')
              }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_button, {
            color: $setup.btnok ? '#fccc06' : '#89dddb',
            round: "",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.ok())),
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('me.submit')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["color"])
        ])
      ])
    ])
  ]))
}